import { chartRed } from '../shared/config';

const title = '';
const rangeSelector = {
  enabled: true,
  buttons: [
    {
      type: 'day',
      count: 1,
      text: '1d',
    },
    {
      type: 'week',
      count: 1,
      text: '1w',
    },
    {
      type: 'month',
      count: 1,
      text: '1m',
    },
    {
      type: 'all',
      text: 'all',
    },
  ],
  inputEnabled: true,
  selected: 0,
  inputBoxWidth: 75,
  inputBoxHeight: 18,
  buttonTheme: {
    height: 18,
    padding: 2,
    undefined: 0,
    width: 15,
    Index: 7,
  },
};

const xAxis = {
  type: 'datetime',
  title: {
    text: 'Time',
  },
  scrollbar: {
    enabled: true,
  },
};

const yAxis = {
  title: {
    text: '',
  },
};
const series = [
  {
    name: '',
    color: chartRed,
    marker: { enabled: false, symbol: 'circle', radius: 2 },
    lineWidth: 2,
    data: [],
  },
];

const chartOptions = () => {
  return {
    title,
    rangeSelector,
    xAxis,
    yAxis,
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
    },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: [
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
            'separator',
            'downloadCSV',
            'downloadXLS',
            'viewData',
          ],
        },
      },
    },
    navigator: {
      enabled: false,
    },
    tooltip: {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
      valueDecimals: 2,
      split: true,
    },
    credits: {
      enabled: false,
    },
    series,
  };
};

export default chartOptions;
